import { apiService } from "../api.service";
import type { LogEntry } from "./logs.types";

export class LogsService {
	async postLog(entry: LogEntry): Promise<void> {
		await apiService.post<void>("/logs", entry);
	}
}

export const logsService = new LogsService();
